import { render, staticRenderFns } from "./issueoutdetail.vue?vue&type=template&id=aff31ad2&scoped=true&"
import script from "./issueoutdetail.vue?vue&type=script&lang=js&"
export * from "./issueoutdetail.vue?vue&type=script&lang=js&"
import style0 from "./issueoutdetail.vue?vue&type=style&index=0&id=aff31ad2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff31ad2",
  null
  
)

export default component.exports